import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { AuthService } from '../auth.service';
import { HelperService } from '../helper.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private auth: AuthService,
    private helperService: HelperService
    ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    const authToken = this.auth.getAuthorizationToken();
    const loginUserDesignation = this.auth.loginUserDesignationData();
    // console.log("req", req?.headers?.get('role-sub-id'));
    // console.log("req", req?.headers?.keys.length);
    
    // let customParams = req.params;
    // customParams.delete('skipOnBehalf');
    // console.log("customParams----------", customParams);

    let aActiveRoleId = this.helperService.getLocalStore('aActiveRole');
    let seva_type = this.helperService.getLocalStore('seva-type');
    
    /*
    * The verbose way:
    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    const authReq = req.clone({
      headers: req.headers.set('Authorization', authToken)
    });
    */
   if(!!authToken && authToken !== undefined && authToken !== null) {
      
      let authHeaderData = {
          Authorization: 'Bearer ' + authToken,
          'role-id': aActiveRoleId.toString()
      };

      let seva_typeHeader = {
        'seva-type' :seva_type
      }
      
      let authHeaderBehalfData = {};
      if(!!req?.headers?.get('role-sub-id') || (req.params.has('skipOnBehalf') && req.params.get('skipOnBehalf'))) {
        
      } else {
        let isOnBehalf = this.helperService.getLocalStore('isOnBehalf');
        let onBehalfUserData = this.helperService.getLocalStore('onBehalfUserData');
        if(!!isOnBehalf && isOnBehalf && !!onBehalfUserData?.additionalHeader) {
          authHeaderBehalfData = onBehalfUserData?.additionalHeader;
        }
      }
      
      // Clone the request and set the new header in one step.
      const authReq = req.clone({ 
        setHeaders: {...authHeaderData, ...authHeaderBehalfData ,...seva_typeHeader},
        params: (req.params.has('skipOnBehalf')) ? req.params.delete('skipOnBehalf') : req.params
      });

      // send cloned request with header to the next handler.
      return next.handle(authReq);
   } else {
      return next.handle(req);
   }

  }
}
